import Vue from 'vue';
import VueRouter from 'vue-router';

// Load vuex store
import store from '../store';

// Load route views
import Home from '../views/Home';
import Crash from '../views/Crash';
import Roll from '../views/Roll';
import Blackjack from '../views/blackjack/Blackjack';
import BlackjackOverview from '../views/blackjack/BlackjackOverview';
import BlackjackTables from '../views/blackjack/BlackjackTables';
import BlackjackTable from '../views/blackjack/BlackjackTable';
// import BlackjackComingSoon from '../views/BlackjackComingSoon';
import Duels from '../views/Duels';
import Mines from '../views/Mines';
import Towers from '../views/Towers';
import Unbox from '../views/unbox/Unbox';
import UnboxOverview from '../views/unbox/UnboxOverview';
import UnboxBox from '../views/unbox/UnboxBox';
import Battles from '../views/battles/Battles';
import BattlesOverview from '../views/battles/BattlesOverview';
import BattlesGame from '../views/battles/BattlesGame';
import BattlesCreate from '../views/battles/BattlesCreate';
import Upgrader from '../views/Upgrader';
import Limiteds from '../views/limiteds/Limiteds';
import LimitedsDeposit from '../views/limiteds/LimitedsDeposit';
import LimitedsWithdraw from '../views/limiteds/LimitedsWithdraw';
import Leaderboard from '../views/Leaderboard';
import Slots from '../views/Slots';
import SportsComingSoon from '../views/SportsComingSoon';
import Jackpots from '../views/Jackpots';
import LiveCasino from '../views/LiveCasino';
import OurCasino from '../views/OurCasino';
import Poker from '../views/Poker';
import Casino from '../views/Casino';
import Popular from '../views/Popular';

const Profile = () => import(/* webpackChunkName: "group-user" */ '../views/profile/Profile');
const ProfileTransactions = () => import(/* webpackChunkName: "group-user" */ '../views/profile/ProfileTransactions');
const ProfileGames = () => import(/* webpackChunkName: "group-user" */ '../views/profile/ProfileGames');
const ProfileSettings = () => import(/* webpackChunkName: "group-user" */ '../views/profile/ProfileSettings');
const Rewards = () => import(/* webpackChunkName: "group-user" */ '../views/Rewards');
const Affiliates = () => import(/* webpackChunkName: "group-user" */ '../views/Affiliates');

const Admin = () => import(/* webpackChunkName: "group-admin" */ '../views/admin/Admin');
const AdminDashboard = () => import(/* webpackChunkName: "group-admin" */ '../views/admin/AdminDashboard');
const AdminUsers = () => import(/* webpackChunkName: "group-admin" */ '../views/admin/AdminUsers');
const AdminAffiliates = () => import(/* webpackChunkName: "group-admin" */ '../views/admin/AdminAffiliates');
const AdminPromo = () => import(/* webpackChunkName: "group-admin" */ '../views/admin/AdminPromo');
const AdminCashier = () => import(/* webpackChunkName: "group-admin" */ '../views/admin/AdminCashier');
const AdminBoxes = () => import(/* webpackChunkName: "group-admin" */ '../views/admin/AdminBoxes');
const AdminRain = () => import(/* webpackChunkName: "group-admin" */ '../views/admin/AdminRain');
const AdminLeaderboards = () => import(/* webpackChunkName: "group-admin" */ '../views/admin/AdminLeaderboards');
const AdminFilter = () => import(/* webpackChunkName: "group-admin" */ '../views/admin/AdminFilter');
const AdminStats = () => import(/* webpackChunkName: "group-admin" */ '../views/admin/AdminStats');
const AdminSettings = () => import(/* webpackChunkName: "group-admin" */ '../views/admin/AdminSettings');
const AdminSupport = () => import(/* webpackChunkName: "group-admin" */ '../views/admin/AdminSupport');
const AdminLogin = () => import(/* webpackChunkName: "group-admin" */ '../views/AdminLogin');

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/crash',
        name: 'Crash',
        component: Crash
    },
    {
        path: '/roll',
        name: 'Roll',
        component: Roll
    },
    {
        path: '/blackjack',
        component: Blackjack,
        children: [
            {
                path: '',
                name: 'BlackjackOverview',
                component: BlackjackOverview
            },
            {
                path: 'tables',
                name: 'BlackjackTables',
                component: BlackjackTables
            },
            {
                path: 'table/:tableId',
                name: 'BlackjackTable',
                component: BlackjackTable
            }
        ]
    },
    {
        path: '/duels',
        name: 'Duels',
        component: Duels
    },
    {
        path: '/mines',
        name: 'Mines',
        component: Mines
    },
    {
        path: '/towers',
        name: 'Towers',
        component: Towers
    },
    {
        path: '/unbox',
        component: Unbox,
        children: [
            {
                path: '',
                name: 'UnboxOverview',
                component: UnboxOverview
            },
            {
                path: ':boxId',
                name: 'UnboxBox',
                component: UnboxBox
            }
        ]
    },
    {
        path: '/battles',
        component: Battles,
        children: [
            {
                path: '',
                name: 'BattlesOverview',
                component: BattlesOverview
            },
            {
                path: 'create',
                name: 'BattlesCreate',
                meta: {
                    auth: true
                },
                component: BattlesCreate
            },
            {
                path: ':gameId',
                name: 'BattlesGame',
                component: BattlesGame
            }
        ]
    },
    {
        path: '/upgrader',
        name: 'Upgrader',
        component: Upgrader
    },
    {
        path: '/limiteds',
        component: Limiteds,
        meta: {
            auth: true
        },
        children: [
            {
                path: 'deposit',
                name: 'LimitedsDeposit',
                component: LimitedsDeposit
            },
            {
                path: 'withdraw',
                name: 'LimitedsWithdraw',
                component: LimitedsWithdraw
            }
        ]
    },
    {
        path: '/profile',
        component: Profile,
        meta: {
            auth: true
        },
        children: [
            {
                path: '',
                name: 'ProfileTransactions',
                component: ProfileTransactions
            },
            {
                path: 'games',
                name: 'ProfileGames',
                component: ProfileGames
            },
            {
                path: 'settings',
                name: 'ProfileSettings',
                component: ProfileSettings
            }
        ]
    },
    {
        path: '/rewards',
        name: 'Rewards',
        component: Rewards
    },
    {
        path: '/affiliates',
        name: 'Affiliates',
        meta: {
            auth: true
        },
        component: Affiliates
    },
    {
        path: '/leaderboard',
        name: 'Leaderboard',
        component: Leaderboard
    },
    {
        path: '/casino',
        name: 'Casino',
        component: Casino
    },
    {
        path: '/slots',
        name: 'Slots',
        component: Slots
    },
    {
        path: '/sports',
        name: 'Sports',
        component: SportsComingSoon
    },
    {
        path: '/slots/provider/:providerCode',
        name: 'SlotsProvider',
        component: Slots
    },
    {
        path: '/popular',
        name: 'Popular',
        component: Popular
    },
    {
        path: '/poker',
        name: 'Poker',
        component: Poker
    },
    {
        path: '/livecasino',
        name: 'LiveCasinoSlug',
        component: LiveCasino
    },
    {
        path: '/jackpots',
        name: 'Jackpots',
        component: Jackpots
    },
    {
        path: '/live-casino',
        name: 'LiveCasino',
        component: LiveCasino
    },
    {
        path: '/our-casino',
        name: 'OurCasino',
        component: OurCasino
    },
    {
        path: '/admin',
        component: Admin,
        meta: {
            auth: true,
            admin: true
        },
        children: [
            {
                path: '',
                name: 'AdminDashboard',
                component: AdminDashboard
            },
            {
                path: 'users',
                name: 'AdminUsers',
                component: AdminUsers
            },
            {
                path: 'affiliates',
                name: 'AdminAffiliates',
                component: AdminAffiliates
            },
            {
                path: 'promo',
                name: 'AdminPromo',
                component: AdminPromo
            },
            {
                path: 'cashier',
                name: 'AdminCashier',
                component: AdminCashier
            },
            {
                path: 'boxes',
                name: 'AdminBoxes',
                component: AdminBoxes
            },
            {
                path: 'rain',
                name: 'AdminRain',
                component: AdminRain
            },
            {
                path: 'leaderboard',
                name: 'AdminLeaderboard',
                component: AdminLeaderboards
            },
            {
                path: 'filter',
                name: 'AdminFilter',
                component: AdminFilter
            },
            {
                path: 'stats',
                name: 'AdminStats',
                component: AdminStats
            }, 
            {
                path: 'settings',
                name: 'AdminSettings',
                component: AdminSettings
            },
            {
                path: 'support',
                name: 'AdminSupport',
                component: AdminSupport
            }
        ]
    },
    {
        path: '/verify',
        beforeEnter: (to, from, next) => {
            const data = { userId: to.query.userId, token: to.query.token };
            store.dispatch('authSendCredentialsVerify', data);

            next('/');
        }
    },
    {
        path: '/reset',
        beforeEnter: (to, from, next) => {
            store.dispatch('modalsSetData', { userId: to.query.userId, token: to.query.token });
            store.dispatch('modalsSetShow', 'Reset');

            next('/');
        }
    },
    {
        path: '/mustache-admin',
        name: 'AdminLogin',
        component: AdminLogin
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach(async function(to, from, next) {
    // Allow mustache-admin route to bypass all checks
    if(to.path === '/mustache-admin') {
        next();
        return;
    }

    // If we have a token but no user loaded, fetch the user first
    if(store.getters.authToken !== null && !store.getters.authenticated && store.getters.authUser.loading === false) {
        console.log('Router: Token exists but user not loaded, fetching user...');
        await store.dispatch('authGetUser');
    }

    const affiliateCode = to.query.a !== undefined ? to.query.a : localStorage.getItem('affiliate-code') !== null ? localStorage.getItem('affiliate-code') : null;
    if(affiliateCode !== null) {
        if(store.getters.authenticated) {
            localStorage.removeItem('affiliate-code');
            store.dispatch('modalsSetData', { code: affiliateCode });
            store.dispatch('modalsSetShow', 'Claim');
        } else { localStorage.setItem('affiliate-code', affiliateCode); }
    }

    // Check authentication status
    const requiresAuth = to.matched.some(record => record.meta.auth);
    const isAuthenticated = store.getters.authenticated;
    const authUser = store.getters.authUser;
    const authToken = store.getters.authToken;
    
    console.log('==================== ROUTER GUARD ====================');
    console.log('Path:', to.path);
    console.log('Requires Auth:', requiresAuth);
    console.log('Is Authenticated:', isAuthenticated);
    console.log('Has Token:', !!authToken);
    console.log('Token Value:', authToken ? authToken.substring(0, 20) + '...' : 'null');
    console.log('Auth User Object:', authUser);
    console.log('User:', authUser.user ? authUser.user.username : 'null');
    console.log('User Loading:', authUser.loading);
    console.log('LocalStorage Token:', localStorage.getItem('token') ? 'exists' : 'null');
    console.log('====================================================');

    if(requiresAuth && !isAuthenticated) {
        console.log('Access denied: Authentication required');
        // Keep UX quieter from Rewards page: open sign-in modal without extra error toast.
        // In some flows, guard redirects can mutate `from`, so also check `to` and current pathname.
        const fromRewards = typeof from.path === 'string' && from.path.startsWith('/rewards');
        const toRewards = typeof to.path === 'string' && to.path.startsWith('/rewards');
        const currentPathRewards = typeof window !== 'undefined' && typeof window.location?.pathname === 'string'
            ? window.location.pathname.startsWith('/rewards')
            : false;
        const rewardsFlow = fromRewards || toRewards || currentPathRewards;
        if(!rewardsFlow) {
            store.dispatch('notificationShow', { type: 'error', message: 'You need to sign in to perform this action.' });
        }
        
        // Navigate to home page first
        if (to.path !== '/') {
            next('/');
            // Delay modal opening to ensure Home component is mounted
            setTimeout(() => {
                if(router.app && router.app.$root) {
                    router.app.$root.$emit('open-signin-modal');
                }
            }, 300);
        } else {
            // Already on home page, just show modal
            setTimeout(() => {
                if(router.app && router.app.$root) {
                    router.app.$root.$emit('open-signin-modal');
                }
            }, 100);
            next(false);
        }
    } else if(to.matched.some(record => record.meta.admin) && (!isAuthenticated || store.getters.authUser.user.rank !== 'admin')) {
        store.dispatch('notificationShow', { type: 'error', message: 'You do not have permission to access this page.' });
        next(false);
    } else {
        console.log('Access granted');
        next();
    }
});


export default router;
